import React from 'react';
import { BetslipContext } from '../../../data/betslip/BetslipConf';
import { getLabel } from '../../../data/labels';
import FastbetAmount from './FastbetAmount';
import OverlayWrapper from '../../OverlayWrapper';

export function FastbetPopup(props) {
    const betslipContext = React.useContext(BetslipContext);

    const fastbetEnabled = betslipContext.isAddAndBetEnabled();

    return (
        <OverlayWrapper id="xs-fastbet-overlay">
            <div className="xs_settingsMenu z-30 absolute container top-0 left-0 right-0 bottom-0">
                <div className="customPopup">
                    <div className="customPopup__content">
                        <div className="customPopup__content__header">
                            <div className="customPopup__content__header__title">
                                <p className="bianco">{fastbetEnabled ? getLabel('live.fastbet_popup.change_amount') : getLabel('live.fastbet_popup.title')}</p>
                            </div>
                            <button className="customPopup__content__header__closeButton" onClick={props.toggle}>
                                <i className="xs-font-icon bi-x-lg"></i>
                            </button>
                        </div>
                        <div className="customPopup__content__body">
                            {betslipContext.isAddAndBetEnabled() ?
                                <FastbetAmount toggle={props.toggle} />
                                :
                                <>
                                    <p>{getLabel('live.fastbet_popup.message')}</p>
                                    <hr />
                                    <FastbetAmount toggle={props.toggle} />
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </OverlayWrapper>
    );
}
